export function testNumberWithDotLength(value, config) {
  const val = config.options.originalValue ? config.options.originalValue : 0
  return (
    (!val.toString().includes('.') ||
      (val.toString().includes('.') && val.toString().split('.')[1].length < 17)) &&
    val.toString().length < 33
  )
}
